// extracted by mini-css-extract-plugin
module.exports = {"siteLogo":"Header_siteLogo__1LbKg","siteHeader":"Header_siteHeader__2d4LK","siteHeaderWrapper":"Header_siteHeaderWrapper__2-WDO"};